import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import {makeStyles, useTheme, ThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import { Tabs, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextInput from '../../components/TextField'
import { green, purple } from '@material-ui/core/colors';
import Joi from '@hapi/joi'
import { useForm } from 'react-final-form-hooks'
import moment from 'moment'
import httpp from '../../service/http'
import validate from '../../service/form/validation'
import formCreateInputs from '../../service/form/create'
// import config from '../../../config'
import Checkbox from '../../components/checkbox'
import {Web3, web3} from 'Backend/Web3'
import ABI from "./ABI";

const DEFAULT_FROM_DATE = moment().format('YYYY-MM-DDTHH:mm')
const DEFAULT_TO_DATE = moment().add(1, 'd').format('YYYY-MM-DDTHH:mm')

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },
    roottomo: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

const theme = createMuiTheme({
    palette: {
        primary: green,
    },
});
function retryGetLink (config, hash, maxRepeat = 50, repeat = 0, delay = 2000) {
    console.log('repeat', repeat)
    const http = httpp(config);
    return http.get({
        path: 'proxy-api',
        params: {url: config.exploreUrl + 'api/txs/' + hash}
    }).then(r => {
        if (r.status !== undefined) return r;
        if (repeat < maxRepeat) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    return resolve(retryGetLink(config, hash, maxRepeat, ++repeat, delay || 1500));
                }, delay || 1500);
            });
        }
        return r;
    }).catch(() => {
        // console.log('error')
        if (repeat < maxRepeat) {
            // recall if api error
            return new Promise((resolve) => {
                setTimeout(() => {
                    return resolve(retryGetLink(config, hash, maxRepeat, ++repeat, delay || 1500));
                }, delay || 1500);
            });
        }
        return null;
    });
}
export default function Tomo({config, userAuth, setTableRows, withLoading, setPageM }) {
    const http = httpp(config)
    const account = userAuth.address
    const classes = useStyles();
    const [initialInputs, updateInitialInputs] = useState({})
    const [isPass, setIsPass] = useState(false)
    const createLink = async (params1) => {
        return new Promise((resolve, reject) => {
            const params = {...params1}
            params.password = isPass ? params1.password : config.defaultPassword
            params.fromDate = moment(params.fromDate).unix()
            params.toDate = moment(params.toDate).unix()
            const contractAddress = config.contractReceiveLink
            // console.log(web3.eth.contract(ABI).at(contractAddress))
            const contract = web3.eth.contract(ABI).at(contractAddress);

            const amount = params.amount * 10 ** 18
            const value = amount * params.num + 1
            const ids = []
            const slugs = [];
            for (let i = 0; i < params.num; i++) {
                ids.push(Math.floor(Math.random() * (9999999999999999999 - 1000000000000000000 + 1)) + 1000000000000000000)
                // generate slug
                let slug = ''
                const possible = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789'
                for (let i = 0; i < 16; i++) {
                    slug += possible.charAt(Math.floor(Math.random() * possible.length))
                }
                slugs.push(slug);
            }
            const dataTx = contract.sendTomos.getData(params.num, ids, amount, params.fromDate, params.toDate);

            // const nonce = await Web3Services.getNonce(userAuth.address);
            const rawTx = {
                from: account,
                to: contractAddress,
                data: dataTx,
                value,
                gasPrice: 1000000000,
                gasLimit: 1000000000,
            }
            // console.log(rawTx)
            web3.eth.sendTransaction(rawTx, (err, res) => {
                if (!err) {
                    setTimeout(() => {
                        retryGetLink(config, res).then((rs) => {
                            if (rs) {
                                console.log(rs)
                                if (rs.status == true) {
                                    const records = []
                                    for (let i = 0; i < params.num; i++) {
                                        const params1 = {...params}
                                        params1.link = config.receiveLink + slugs[i]

                                        records.push({
                                            userAddress: userAuth.address,
                                            hash: res,
                                            code: ids[i].toString(),
                                            slug: slugs[i],
                                            type: 'tomo',
                                            metaData: params1,
                                            isPassword: isPass
                                        })
                                    }
                                    http.post({
                                        path: 'receive-link',
                                        payload: records
                                    }).then(() => setPageM(0))
                                } else reject(rs)
                            }
                        }).catch(err => {
                            console.log('sendTomo - error: ', err)
                            reject(res)
                        });
                    }, 5000)
                } else {
                    console.error(err);
                    reject(err)
                }
            })
        })
    }
    const onSubmit = async (params) => {
        withLoading(() => createLink(params))

    }
    const schema = Joi.object().keys({
        num: Joi.number().integer().min(1).max(250).required(),
        amount: Joi.number().required(),
        fromDate: Joi.date().required(),
        toDate: Joi.date().required(),
        password: Joi.string().max(4).allow(null),
    })
    const { form, handleSubmit } = useForm({
        onSubmit,
        validate: validate(schema),
        initialValues: initialInputs
    })
    const [num, amount, fromDate, toDate, password] = formCreateInputs(['num', 'amount', 'fromDate', 'toDate', 'password'], form)

    useEffect(() => {
        if(!initialInputs.num) updateInitialInputs({
            num: 1,
            amount: 1,
            fromDate: DEFAULT_FROM_DATE,
            toDate: DEFAULT_TO_DATE,
            // password: config.defaultPassword,
        })

    }, [])
    const handleChangeIsPass = (status) => {
        setIsPass(status)
        // console.log(status, isPass)
    }

    return (
        <form onSubmit={handleSubmit} className={classes.roottomo} noValidate autoComplete="off">
            <div className="myInput">
                <TextInput input={num} label="Num of link" />
                <TextInput input={amount} label="Amount" />
                <TextInput style={{marginLeft: 15, width: 200}} input={fromDate} label='Start Time' type='datetime-local' InputLabelProps={{
                    shrink: true,
                }}/>

                <TextInput
                    input={toDate}
                    id="datetime-local"
                    label="End Time"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <Checkbox checked={isPass} label={'Is Password'} handleChangeIsPass={handleChangeIsPass}/>

                {isPass && <TextInput
                    input={password}
                    id="standard-helperText"
                    type="number"
                    label="Password"
                    helperText="Receiver need this info to get, Please input exactly 4 numbers only!"
                />}

            </div>

            <ThemeProvider theme={theme}>
                <Button type='submit' variant="contained" color="primary"  className={`btn ${classes.margin}`}>
                    Submit
                </Button>
            </ThemeProvider>
        </form>
    );
}
